if (!customElements.get('gms-fondue-video')) {
  customElements.define('gms-fondue-video', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video || this.observer) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          if (!reducedMotion.matches && !navigator.connection?.saveData) video.play().catch(() => {});
        } else video.pause();
      }, { threshold: 0.35 });
      this.observer.observe(video);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.querySelector('video')?.pause();
    }
  });
}
